import React from 'react';
import VistaToggle from './VistaToggle';
import FieldPicker from './FieldPicker';

// Controles de listado para la barra de filtros: botón "Campos" (elegir y
// ordenar por arrastre los campos que se ven; la selección y el orden son
// PROPIOS de cada modalidad) + conmutador tabla/tarjetas. Se coloca alineado a
// la derecha de la barra de cada pantalla.
//
// Props: viewMode, onViewModeChange, fields ([{key,label}] ya ordenados),
//        hidden ([keys]), onToggleField (key => void),
//        onReorderFields (keys => void).
const VistaControles = ({
  viewMode,
  onViewModeChange,
  fields = [],
  hidden = [],
  onToggleField,
  onReorderFields,
}) => (
  <div className="vista-controles">
    <FieldPicker
      fields={fields}
      hidden={hidden}
      onToggle={onToggleField}
      onReorder={onReorderFields}
      viewMode={viewMode}
    />
    <VistaToggle value={viewMode} onChange={onViewModeChange} />
  </div>
);

export default VistaControles;
